import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { auth } from '@/api/auth'
import { BASE_URL } from '@/api/api'

class IncidentAttachmentService extends AttachmentResource {
    async getIncidentAttachments(laboratoryId, incidentId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/incidents/${incidentId}/attachments`)
        return response.data
    }

    async addAttachment(labId, incId, attachmentTypeId, file, thumbnailBytes) {
        let thumbnail

        if (thumbnailBytes) {
            thumbnail = this.base64ToBlob(thumbnailBytes, file.name)
        } else {
            let generatedThumbnailBytes = await this.thumbnailifyFromBlob(file)
            thumbnail = this.base64ToBlob(generatedThumbnailBytes, file.name)
        }

        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('atyId', attachmentTypeId)

        if (thumbnail) {
            formData.append('thumbnail', thumbnail, file.name)
        }

        const response = await this.axios.post(
            `/common/laboratories/${labId}/incidents/${incId}/attachments`,
            formData, { headers: { 'content-type': 'multipart/form-data' } })

        return response.data
    }

    async getFile(labId, incId, attId) {
        return this.axios.get(`/common/laboratories/${labId}/incidents/${incId}/attachments/${attId}`, {
            headers: { 'content-type': 'multipart/form-data' },
            responseType: 'blob'
        }).then(response => response.data)
    }

    getUrlFile(laboratoryId, incidentId, attachmentId) {
        return `${BASE_URL}/common/laboratories/${laboratoryId}/incidents/${incidentId}/attachments/${attachmentId}?authenticationToken=${auth.token}`
    }

    async deleteAttachment(labId, incId, attId) {
        const response = await this.axios.delete(`/common/laboratories/${labId}/incidents/${incId}/attachments/${attId}`)
        return response.data
    }
}

export default new IncidentAttachmentService()
